import React from 'react';
import { FormField } from '../../FormField/FormField';
import { UserDisplay } from '../../UserDisplay/UserDisplay';
import { Reservation } from '../../../types/reservation';

interface Props {
  createdBy: NonNullable<Reservation['createdBy']>;
}

/** Who created the reservation in the app. It is not the assigned employee. */
export const CreatedByField = ({ createdBy }: Props) => (
  <FormField
    labelTitle='Creado por'
    elementId='reservation-created-by'
    fullWidth
    infoTooltip='Solo indica quién creó la reserva en la app. No es la persona asignada.'
  >
    <UserDisplay name={createdBy.name} surnames={createdBy.surnames} avatarUrl={createdBy.avatarUrl} />
  </FormField>
);
